import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService, HttpErrorHandlingService } from '@app/core';
import { Const, Rol } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';

/**
 * Modelo de roles
 *
 * @export
 * @interface AssignationTaskDataService
 */
 export interface RolDefault {
  id: number;
  nombre: string;
  activo?: boolean;
}

@Injectable()
export class AssignationTaskDataService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService, private hehs: HttpErrorHandlingService) {}


   /**
   * Consulta los roles del sistema(grupos).
   *
   * @returns {Observable<RolDefault[]>}
   * @memberof AssignationTaskDataService
   */
    getRoles(): Observable<RolDefault[]> {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.utilityRol;
      return this.http.get<RolDefault[]>(this.api.addParams(path, 'simple', []));
    }
  
  /**
   * Consulta un rol(grupo).
   *
   * @param {number} idRol
   * @returns {Observable<Rol>}
   * @memberof AssignationTaskDataService
   */
  getRole(idRol: number): Observable<Rol> {
    return this.http.get<Rol>(this.api.get('roles', [idRol]));
  }


  /**
   * actualiza la actividad
   *
   * @param {number} task
   * @param {list} responsables
   * @return {*}  
   * @memberof AssignationTaskDataService
   */
   createAssignmentTask(task: any, responsables?: any): Promise<any> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.utilityAssignmentTask;
    let dataForm = {};
    dataForm['tarea_id'] = task;
    dataForm['responsables'] = responsables;
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().post<any>(this.api.addParams(path, 'simple', []), dataForm).subscribe(
        data => {
          this.toastr.success('Asignación creada correctamente','Operación exitosa');
          resolve(data);
        },
        err => {
          if (err.status !== 401 && err.status !== 403 && err.status != 400) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }else if(err.status == 400){
            this.toastr.warning(err.error, 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/assignation-task/shared/assignation-task.data.service.ts